import React, { useState } from 'react';
import jet, { useDrag, useDrift, usePromise } from "@randajan/jet-react";
import { Link, LinkTel, LinkMail } from "@randajan/jet-react/dom/link";

import "./FootPane.scss";
import { Contact } from './Contact/Contact';
import { Img } from '@randajan/jet-react/dom/img';
import { usePageContact } from '../../hooks/usePageContact';
import { bifrost } from '../../config/bifrost';


const _undragable = ["SPAN", "A", "H1", "H2", "H3", "H4", "H5", "H6"];

export const FootPane = ()=>{
    const [ isOpen, setOpen ] = usePageContact();
    const { result:contact, status } = usePromise({}, _=>bifrost.tx("sunGetContact"), []);

    const [ ref, move ] = useDrag((bound, id)=>{
        const { event } = bound;

        if (event?.button || (bound.state === "start" && _undragable.includes(event?.target?.tagName))) { bound.stop(); }

        if (id !== bound.id) { return; }
        bound.relY = Number.jet.frame(bound.relY, -5, 6);
        if (bound.state !== "stop" || !bound.event) { return; }
        if (bound.time > 135 && (bound.dist / bound.parent.height) < 1.5) { return; }
        setOpen(!isOpen);
    }, {
        initX:.5,
        initY:isOpen ? -5 : 6,
        up:.66,
        left:0,
        right:0,
        down:.66,
        autoReset:true,
        appendState:true,
    });

    const mail = contact.email?.split("; ")[0];
    const phone = contact.phone?.split("; ")[0];

    return (
        <div className={jet.melt(["FootPane", isOpen ? "isOpen" : "isClosed"], " ")} data-status={status}>
            <div className="dragable" ref={ref}>
                <div className="mist"/>
                <div className="handle wall">
                    <div className="block">
                    <p><LinkMail className="email" to={mail}><Img src="/icons/email.svg"/><span>{mail}</span></LinkMail></p>
                    <p className="copyright">© {contact.alias} {new Date().getFullYear()}</p>
                    <p><LinkTel className="hotline" to={phone}><Img src="/icons/tel.svg"/><span>{phone}</span></LinkTel></p>
                    </div>
                </div>
                <div className="content wallGray">
                    <Contact {...contact}/>
                </div>
            </div>
        </div>
    )
}

export default FootPane;
